import { render } from "./BandMember.vue?vue&type=template&id=d35dd0b8&scoped=true"
import script from "./BandMember.vue?vue&type=script&lang=js"
export * from "./BandMember.vue?vue&type=script&lang=js"

import "./BandMember.vue?vue&type=style&index=0&id=d35dd0b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d35dd0b8"]])

export default __exports__